import React from 'react';
import {Button} from "react-materialize";
import ClientRateForm from "../../forms/ClientRateForm";
import * as utils from "../../../utils/utils";
import * as moment from "moment";
import * as creationActions from "../../../actions/creation";
import * as clientRateActions from "../../../actions/clientRate";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export default class RateItem extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            dialogActive: false
        };
    }
    handleDelete = () => {
        this.props.dispatch(clientRateActions.deleteClientrate(this.props.item.id));
    };

    render() {
        return (
            <tr>
                <td>{this.props.item.name}</td>
                <td>{utils.notNullNorUndefined(this.props.item.creationDate) && moment.unix(this.props.item.creationDate).format('DD/MM/Y')}</td>
                <td>{this.props.item.isMarineOnly ? 'true' : 'false'}</td>
                <td>{this.props.item.rate}</td>
                <td>{this.props.item.franchise}</td>
                <td>
                    <Button floating onClick={() => this.props.openDrawer(ClientRateForm, {item: this.props.item, client: this.props.client}, creationActions.destroyingnewlyCreatedClientRate())} icon="edit" className="edit-button" />
                    <Button disabled={this.props.deletingClientrate} floating onClick={()=> this.setState({dialogActive: true})} icon="delete" className="delete-button btn btn-floating"/>
                </td>
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false}) },
                        { label: "Yes", onClick: () => {this.handleDelete(); this.setState({dialogActive:false}); }}
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this rate ?</p>
                </Dialog>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/client/clientRate/RateItem.js